import PublicEnv from 'shared/utils/public-env';
import { setComplianceConfigOverride } from './compliance';

/**
 * Applies the remote compliance config that the API delivered to the browser via the react-env
 * (`window.reactEnv` -> PublicEnv) channel. Synchronous and idempotent-safe to call once at app
 * boot: when the config is present the override is set, otherwise the statically-bundled config
 * is used. The API only includes the config when its own LD kill-switch is on, so there's a single
 * gate on the API side and the browser just applies whatever it was handed.
 */
export const applyRemoteComplianceConfig = () => {
  const config = PublicEnv.complianceConfig;
  if (config) {
    setComplianceConfigOverride(config);
  }
};
